import React from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export const call = async (fn, ok) => {
  try { const r = await fn(); if (ok) toast.success(ok); return r.data; } catch (x) { toast.error(x.response?.data?.detail || "Action failed"); return null; }
};

const ST = { draft: "bg-slate-100 text-slate-700", in_review: "bg-amber-50 text-amber-800", approved: "bg-emerald-50 text-emerald-700" };
export function StatusBadge({ s, testId }) {
  return <span className={`text-[11px] font-semibold px-2 py-0.5 rounded uppercase ${ST[s] || "bg-slate-100"}`} data-testid={testId}>{s?.replace("_", " ")}</span>;
}

export const TestTag = () => <span className="text-[10px] font-bold px-1.5 py-0.5 rounded bg-fuchsia-50 text-fuchsia-700" data-testid="pim-test-tag">PREVIEW TEST DATA</span>;

export function Avail({ a }) {
  const t = a.mode === "stock" ? `${a.available} available` : a.mode === "unmapped" ? "No stock mapping" : a.mode === "unlimited" ? "Non-stock (always available)" : "No stock (deposit)";
  return <span className={`text-xs ${a.mode === "unmapped" ? "text-rose-700" : "text-slate-600"}`}>{t}</span>;
}

export const get = (u) => api.get(u).then((r) => r.data);
